import axios from "axios"
import { httpAgent, httpsAgent } from "./galleryApiAgents"

const client = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  httpAgent,
  httpsAgent,
  headers: {
    "API-KEY": `${process.env.API_KEY}`,
  },
})

client.interceptors.response.use(
  (response) => {
    return response
  },
  function (error) {
    return Promise.reject(error)
  },
)

export const axiosGalleryClient = client
